module.exports = __webpack_public_path__ + "img/SKMJ_limit2.ffa0ad5a.jpg";